import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { Referral } from '../interfaces/referral.interface';
import { AppConfigService } from '../providers/config.service';

@Injectable({
  providedIn: 'root',
})
export class ReferralService {
  offers: { key: string; code: string; productName?: string }[] = [
    { key: 'stref', code: 'PICREF20' },
    { key: 'koabc', code: 'PICREF10' },
  ];

  constructor(private http: HttpClient, private config: AppConfigService) {}

  public async getReferrals(): Promise<Referral[]> {
    const resp = await lastValueFrom(
      this.http.get<{ data: Referral[] }>(`${this.config.apiEndpoint}/referrals?expand[]=data.user`)
    );
    return resp.data;
  }

  public async deleteReferral(id: string) {
    await lastValueFrom(this.http.delete(`${this.config.apiEndpoint}/referrals/${id}`));
  }

  private getOffer(offerKey: string) {
    const offer = this.offers.find(o => o.key === offerKey);
    if (offer) return offer;
    return this.offers[0];
  }

  public getProductName(offerKey: string): string {
    return this.getOffer(offerKey).productName;
  }

  public getPromoCode(offerKey: string): string {
    return this.getOffer(offerKey).code;
  }
}
